import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Backdrop, CircularProgress } from "@mui/material";
import {
  Button,
  Col,
  Popconfirm,
  Row,
  Table,
  TableProps,
  Typography,
} from "antd";
import { SorterResult } from "antd/es/table/interface";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import {
  DeleteGroupList,
  GetGroupsList,
  axiosErrorMessages,
} from "../../../../API/api";
import { useAppRole } from "../../../../API/RoleContext";
import AdminLayout from "../../../../component/AdminLayout";
import SearchBar from "../../../../component/Search";
import { customSortDirections } from "../../../../Utils/utils";
import AddEditGroups from "../components/AddEditGroups";
import axios, { AxiosError } from "axios";
import GroupEmployeeList from "../../../../component/GroupEmployeeList";

interface GroupsItem {
  groupId: number;
  groupName: string;
  groupEmailId: string;
}
const EmailGroups = () => {
  const appRole = useAppRole();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isAddNewGroup, setIsAddNewGroup] = useState<boolean>(false);
  const [editData, setEditData] = useState({});
  const [isAdd, setIsAdd] = useState<boolean>(true);
  const [sortedInfo, setSortedInfo] = useState<SorterResult<GroupsItem>>({});
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState<GroupsItem[]>([]);
  const [groupList, setGroupList] = useState([]);
  const [pagesize, setPageSize] = useState<number>(50);
  const [employeeList, setEmployeesList] = useState([]);
  const [isEmployeeListModalOpen, setIsEmployeeListModalOpen] =
    useState<boolean>(false);
  useEffect(() => {
    fetchGroupsList();
  }, []);

  const fetchGroupsList = async () => {
    try {
      setIsLoading(true);
      const response = await GetGroupsList();
      const newData = response.data.map((groups: any, index: number) => ({
        ...groups,
        key: groups.groupId,
      }));
      setGroupList(newData);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };

  const handleSearch = (value: string) => {
    setCurrentPage(1);
    setSearchText(value);
    filterData(value);
  };
  const handleAddNewDevice = () => {
    setIsAdd(true);
    setIsAddNewGroup(true);
  };
  const filterData = (searchText: string) => {
    if (!searchText) {
      setFilteredData([]);
    } else {
      const filtered = groupList.filter((item: any) =>
        item.groupName.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };
  const handleDelete = (rowData: any) => {
    setIsLoading(true);
    DeleteGroupList(rowData)
      .then((response: any) => {
        enqueueSnackbar("Deleted Successfully", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });

        setIsLoading(false);
        fetchGroupsList();
      })
      .catch((error: any) => {
        if (error.response.data.errors.Group[0]) {
          enqueueSnackbar(error.response.data.errors.Group[0], {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        } else {
          let errorMsg;
          if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError;
            errorMsg = axiosErrorMessages(axiosError);
          } else {
            errorMsg = error.message;
          }
          enqueueSnackbar(errorMsg, {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        }

        setIsLoading(false);
      });
  };
  const handleGroupCount = (text: any) => {
    setEmployeesList(text.groupUsers);
    setIsEmployeeListModalOpen(true);
  };
  const edit = (rowData: any) => {
    setIsAdd(false);
    setEditData(rowData);
    setIsAddNewGroup(true);
  };
  const handleClose = () => {
    setIsAddNewGroup(false);
    fetchGroupsList();
  };
  const handleChange: TableProps<GroupsItem>["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {
    setSortedInfo(sorter as SorterResult<GroupsItem>);
    setCurrentPage(pagination.current || 1);
    setPageSize(pagination.pageSize ?? 50);
  };

  const columns = [
    {
      title: "No",
      dataIndex: "id",
      key: "id",
      width: "10%",
      render: (text: any, record: any, index: number) =>
        (currentPage - 1) * pagesize + index + 1,
    },
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
      sorter: (a: any, b: any) => a.groupName.localeCompare(b.groupName),
      sortOrder: sortedInfo.columnKey === "groupName" ? sortedInfo.order : null,
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "Group Email ID",
      dataIndex: "groupEmailId",
      key: "groupEmailId",
      sorter: (a: any, b: any) => a.groupEmailId.localeCompare(b.groupEmailId),
      sortOrder:
        sortedInfo.columnKey === "groupEmailId" ? sortedInfo.order : null,
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "Employee Count",
      dataIndex: "employeeCount",
      key: "employeeCount",
      render: (text: string, record: any) => (
        <div>
          <Button type="link" disabled={record.groupUsers.length === 0} onClick={() => handleGroupCount(record)}>
            {record.groupUsers.length}
          </Button>
        </div>
      ),
    },
    ...(appRole
      ? [
          {
            title: "Action",
            dataIndex: "action",
            width: "20%",

            render: (_: any, record: any) => {
              return (
                <>
                  {" "}
                  <Typography.Link onClick={() => edit(record)}>
                    <EditOutlined />
                  </Typography.Link>
                  <Popconfirm
                    title="Do you want to delete the group?"
                    onConfirm={() => handleDelete(record.key)}
                  >
                    <Typography.Link className="delete-btn">
                      <DeleteOutlined />
                    </Typography.Link>
                  </Popconfirm>
                </>
              );
            },
          },
        ]
      : []),
  ];
  return (
    <>
      <AdminLayout>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div style={{ margin: "25px" }}>
          <div className="employee-table-header ">
            <Row gutter={16}>
              <Col className="gutter-row" lg={12} sm={24}>
                <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                  Email Groups
                </h3>
              </Col>
              <Col className="gutter-row pm-search-flex" lg={12} sm={24}>
                <SearchBar
                  width={"50%"}
                  onSearch={handleSearch}
                  placeholder={"Search Groups"}
                />
                {appRole && (
                  <Button
                    onClick={handleAddNewDevice}
                    type="primary"
                    style={{ marginLeft: 10 }}
                    size="small"
                  >
                    Add New
                  </Button>
                )}
              </Col>
            </Row>
          </div>

          <Table
            sortDirections={customSortDirections}
            className="status-list-admin"
            columns={columns}
            size="small"
            onChange={handleChange}
            pagination={{
              current: currentPage,
              showSizeChanger: true,
              defaultPageSize: 50,
            }}
            rowClassName="editable-row"
            dataSource={searchText ? filteredData : groupList}
          />

          {isAddNewGroup && (
            <AddEditGroups
              isAdd={isAdd}
              editData={editData}
              handleClose={handleClose}
            />
          )}
        </div>
        {isEmployeeListModalOpen && (
          <GroupEmployeeList
            listData={employeeList}
            closePopup={() => setIsEmployeeListModalOpen(false)}
          />
        )}
      </AdminLayout>
    </>
  );
};
export default EmailGroups;
